import { render, staticRenderFns } from "./AllegatiStandardModal.vue?vue&type=template&id=1e01b5ed&scoped=true&"
import script from "./AllegatiStandardModal.vue?vue&type=script&lang=js&"
export * from "./AllegatiStandardModal.vue?vue&type=script&lang=js&"
import style0 from "./AllegatiStandardModal.vue?vue&type=style&index=0&id=1e01b5ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01b5ed",
  null
  
)

component.options.__file = "AllegatiStandardModal.vue"
export default component.exports